import { render, staticRenderFns } from "./NoneData.vue?vue&type=template&id=b662009a&scoped=true&"
import script from "./NoneData.vue?vue&type=script&lang=js&"
export * from "./NoneData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b662009a",
  null
  
)

export default component.exports